import { AlertCircle, CheckCircle } from 'lucide-react'

interface FlashMessagesProps {
    message?: string
    flash?: {
        notice?: string
        alert?: string
    }
}

export default function FlashMessages({ message, flash }: FlashMessagesProps) {
    return (
        <>
            {(message || flash?.notice) && (
                <div className="mb-6 bg-green-50 border border-green-200 rounded-md p-4">
                    <div className="flex">
                        <CheckCircle className="h-5 w-5 text-green-400"/>
                        <div className="ml-3">
                            <p className="text-sm text-green-700">{message || flash?.notice}</p>
                        </div>
                    </div>
                </div>
            )}

            {flash?.alert && (
                <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4">
                    <div className="flex">
                        <AlertCircle className="h-5 w-5 text-red-400"/>
                        <div className="ml-3">
                            <p className="text-sm text-red-700">{flash.alert}</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}